// extracted by mini-css-extract-plugin
export default {"root":"z1NpGG","text":"Ju1w6U","button":"KkiWHV"};